import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV } from "@/constants/testIds";

const links = [
  { to: "/", label: "Home", tid: NAV.linkHome },
  { to: "/#services", label: "Services", tid: NAV.linkServices },
  { to: "/#gallery", label: "Gallery", tid: NAV.linkGallery },
  { to: "/pickup", label: "Dry Cleaning Pickup", tid: "nav-link-pickup" },
  { to: "/track", label: "Track Order", tid: NAV.linkTrack },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  const onAdmin = loc.pathname.startsWith("/admin");
  if (onAdmin) return null;

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#FFFFFF]/80 border-b border-[#E2E8F0]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid={NAV.logo} className="flex items-baseline gap-2">
          <span className="font-serif-display text-2xl md:text-3xl tracking-tight">Hedieh's</span>
          <span className="overline hidden sm:inline">Alterations · Sydney</span>
        </Link>
        <nav className="hidden md:flex items-center gap-10">
          {links.map(l => (
            <a key={l.to} href={l.to} data-testid={l.tid}
               className="text-sm tracking-wide text-[#0F172A] link-underline">
              {l.label}
            </a>
          ))}
          <Link to="/book" data-testid={NAV.linkBook}
                className="px-6 py-3 bg-[#D4AF37] text-[#0F172A] text-xs uppercase tracking-[0.2em] hover:bg-[#B8941F]">
            Book a Fitting
          </Link>
        </nav>
        <button data-testid={NAV.mobileToggle} className="md:hidden p-2" onClick={() => setOpen(!open)}>
          {open ? <X size={22}/> : <Menu size={22}/>}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-[#E2E8F0] bg-[#FFFFFF]">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map(l => (
              <a key={l.to} href={l.to} onClick={() => setOpen(false)} className="text-base">{l.label}</a>
            ))}
            <Link to="/book" onClick={() => setOpen(false)}
                  className="px-6 py-3 bg-[#0F172A] text-[#FFFFFF] text-xs uppercase tracking-[0.2em] text-center">
              Book a Fitting
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
